import * as types from "./mutations-types";

export default {
    [types.SET_TAXES_LIST](state, list) {
        state.taxes_list = list;
    },
    [types.SET_TAX_CATEGORIES_LIST](state, list) {
        state.tax_categories_list = list;
    }
};
